import type { IconData } from '@stacksjs/iconify-core'

export const bookmarkF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h8a3 3 0 0 1 3 3v15a2 2 0 0 1-3.348 1.477L7.674 16.76a1 1 0 0 0-1.348 0l-2.978 2.717A2 2 0 0 1 0 18V3a3 3 0 0 1 3-3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default bookmarkF
